import BaseObject from "../../../base/base_object";
import _ from "../../../utils/underscore";

export default class MainRestrictionParser extends BaseObject {
     parse(restrictionData) {
        let restriction = restrictionData.Restrictions;
        let restrictionsByAction = [];

        if (!restriction) {
            this.logger.info('Restriction key is not found in event data. There is no restrictions!');
            return [];
        }

        if (!restriction.RestrictionAction && !restriction.RestrictionActions) {
            this.logger.info('There is no restriction action / actions found in event data!');
            return [];
        }

        // single action
        if (restriction.RestrictionAction) {
            restrictionsByAction.push(this._formatToCGPRestrictionAction(restriction.RestrictionAction));
        }

        // multiple actions
        if (restriction.RestrictionActions) {
            restriction.RestrictionActions.forEach((action) => {
                let restrictionObj  = this._formatToCGPRestrictionAction(action);
                restrictionsByAction.push(restrictionObj);
            });
        }

        return restrictionsByAction;
    }


    _formatToCGPRestrictionAction(restrictionAction) {
        let action = {
            ActionId: restrictionAction['@Id'],
            ActionName:  restrictionAction['@Name'],
        };
        // single entity
        let entities = [];
        if (restrictionAction.Restriction) {
            entities.push(this._parseEntity(restrictionAction.Restriction));
        }
        // multiple entities
        if (restrictionAction.Restrictions && _.isArray(restrictionAction.Restrictions)) {
            restrictionAction.Restrictions.forEach((restriction) => {
                entities.push(this._parseEntity(restriction));
            });
        }

        action.Entities = entities;
        return action;
    }

    _parseEntity(restriction) {
         let entity = {
             EntityId: restriction['@EntityID'],
             EntityName: restriction['@EntityName'],
             Values: []
         };

         let restrictionValues = [];
        if (restriction.Value) {
            restrictionValues = _.isArray(restriction.Value) ? restriction.Value : [restriction.Value];
        }
        if (restriction.Values && _.isArray(restriction.Values)) {
            restrictionValues = restriction.Values;
        }
        restrictionValues.forEach((value) => {
            entity.Values.push(this._parseRestrictionValue(value));
        });

        return entity;
    }


    _parseRestrictionValue(restrictionValue) {
         return {
             ExpirationDate: restrictionValue['@ExpirationDate'],
             ReasonId: restrictionValue['@ReasonID'],
             SecondsToExpire: restrictionValue['@SecondsToExpire'],
             Value: restrictionValue['#text']
         }
    }
}